export const FLOOR_COVERING_CONFIGURATION_TYPE = 'FLOOR_COVERING';
